<br /><br /><br /><br />
<div class="page-title">
  <h1 class="title-text">Good Catch</h1>
  <p class="form-desc"></p>
</div>
<br />

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <form [formGroup]="form" appSubmitDiag="goodcatch" (ngSubmit)="create()">
      <br />
      <mat-form-field appearance="fill">
        <mat-label>Your Email:</mat-label>
        <input
          matInput
          placeholder="Enter email"
          formControlName="email"
          required
          />
        </mat-form-field>
        <br />
        <mat-label class="qTitle">Report Type (Required)</mat-label>
        <br /><br />
        <mat-radio-group formControlName="type" name="type" required>
          <mat-radio-button value="good catch">Good Catch</mat-radio-button>
          <mat-radio-button value="stop work authority"
            >Stop Work Authority</mat-radio-button
            >
          </mat-radio-group>
          <br /><br />

          <mat-form-field appearance="fill">
            <mat-label>Today's Date:</mat-label>
            <input
              matInput
              [matDatepicker]="picker2"
              formControlName="dateOfReport"
              required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Incident Date:</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="incidentDate"
                required
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Time of Good Catch/Stop Work:</mat-label>
                <input matInput [matTimepicker]="timePicker" formControlName="time" required>
                <mat-timepicker-toggle matIconSuffix [for]="timePicker"/>
                <mat-timepicker #timePicker/>
              </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>Project Supervisor:</mat-label>
                  <input
                    matInput
                    formControlName="supervisor"
                    placeholder="Enter project supervisor"
                    required
                    />
                  </mat-form-field>

                  <mat-form-field appearance="fill">
                    <mat-label>Office:</mat-label>
                    <mat-select formControlName="office" required>
                      @for (office of offices; track office.value) {
                        <mat-option [value]="office.value">{{ office.label }}</mat-option>
                      }
                    </mat-select>
                    <mat-error>This field is required</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="fill">
                    <mat-label>Location of Good Catch/Stop Work:</mat-label>
                    <input
                      matInput
                      formControlName="location"
                      placeholder="Enter location"
                      required
                      />
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                      <mat-label
                        >Type of Good Catch/Stop Work (Driving, Lifting, Fall, Slip
                        etc.):</mat-label
                        >
                        <input
                          matInput
                          formControlName="typeCatch"
                          placeholder="Enter type of Near Miss"
                          required
                          />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                          <mat-label>Company Equipment/Vehicles/Tools Involved:</mat-label>
                          <input
                            matInput
                            formControlName="equipment"
                            placeholder="Enter items involved"
                            required
                            />
                          </mat-form-field>

                          <mat-form-field appearance="fill">
                            <mat-label>Company Personnel Involved (Optional):</mat-label>
                            <input
                              matInput
                              formControlName="persons"
                              placeholder="Enter personnel involved"
                              />
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                              <mat-label>Details of Good Catch/Stop Work:</mat-label>
                              <input
                                matInput
                                formControlName="desc"
                                placeholder="Enter details"
                                required
                                />
                              </mat-form-field>
                              <br />
                              <mat-label class="qTitle"
                                >Rate the potential for serious injury (Required):</mat-label
                                >
                                <br /><br />
                                <mat-radio-group formControlName="rate" name="rate">
                                  <mat-radio-button value="low">Low</mat-radio-button>
                                  <mat-radio-button value="moderate">Moderate</mat-radio-button>
                                  <mat-radio-button value="high">High</mat-radio-button>
                                </mat-radio-group>
                                <br /><br />

                                <mat-form-field appearance="fill">
                                  <mat-label>Corrective Actions/Steps Taken:</mat-label>
                                  <input
                                    matInput
                                    formControlName="actions"
                                    placeholder="Enter actions/steps taken"
                                    required
                                    />
                                  </mat-form-field>

                                  <mat-form-field appearance="fill">
                                    <mat-label
                                      >Date Good Catch/Stop Work was discussed with crew:</mat-label
                                      >
                                      <input
                                        matInput
                                        [matDatepicker]="picker3"
                                        formControlName="dateDiscussed"
                                        required
                                        />
                                        <mat-datepicker-toggle
                                          matSuffix
                                          [for]="picker3"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker #picker3></mat-datepicker>
                                      </mat-form-field>

                                      <mat-form-field appearance="fill">
                                        <mat-label>Report Completed By:</mat-label>
                                        <input
                                          matInput
                                          formControlName="completedBy"
                                          placeholder="Enter name"
                                          required
                                          />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                          <mat-label>Job Title</mat-label>
                                          <input
                                            matInput
                                            formControlName="title"
                                            placeholder="Enter job title"
                                            required
                                            />
                                          </mat-form-field>

                                          <mat-label class="note"
                                            >By entering your name below, you are verifying that the statements and
                                            information provided are true and correct, and you are attesting to the
                                            validity of all contents within this electronic submission. By clicking
                                            on the submit button, you are deemed to have electronically signed this
                                            statement.</mat-label
                                            >
                                            <br /><br />
                                            <mat-form-field appearance="fill">
                                              <mat-label>Signature:</mat-label>
                                              <input
                                                matInput
                                                formControlName="signature"
                                                placeholder="Please sign"
                                                required
                                                />
                                              </mat-form-field>

                                              <mat-label class="note"
                                                >Please click below for additional signatures:</mat-label
                                                >
                                                <button
                                                  mat-button
                                                  type="button"
                                                  (click)="showAdditionalSignatures = !showAdditionalSignatures"
                                                  >
                                                  {{
                                                  showAdditionalSignatures
                                                  ? "Hide Additional Signatures"
                                                  : "Add More Signatures"
                                                  }}
                                                </button>

                                                @if (showAdditionalSignatures) {
                                                  <div>
                                                    <mat-form-field appearance="fill">
                                                      <mat-label>Additional Signature 1</mat-label>
                                                      <input
                                                        matInput
                                                        formControlName="signatureOne"
                                                        placeholder="Please Sign"
                                                        />
                                                      </mat-form-field>
                                                      <mat-form-field appearance="fill">
                                                        <mat-label>Additional Signature 2</mat-label>
                                                        <input
                                                          matInput
                                                          formControlName="signatureTwo"
                                                          placeholder="Please Sign"
                                                          />
                                                        </mat-form-field>
                                                        <mat-form-field appearance="fill">
                                                          <mat-label>Additional Signature 3</mat-label>
                                                          <input
                                                            matInput
                                                            formControlName="signatureThree"
                                                            placeholder="Please Sign"
                                                            />
                                                          </mat-form-field>
                                                          <mat-form-field appearance="fill">
                                                            <mat-label>Additional Signature 4</mat-label>
                                                            <input
                                                              matInput
                                                              formControlName="signatureFour"
                                                              placeholder="Please Sign"
                                                              />
                                                            </mat-form-field>
                                                          </div>
                                                        }
                                                        <div class="button-container">
                                                          <button mat-raised-button color="primary" class="submit-button" [disabled]="isSubmitting">
                                                            {{ isSubmitting ? 'Submitting…' : 'Submit' }}
                                                          </button>
                                                        </div>

                                                        @if (isSubmitting) {
                                                          <div class="custom-spinner-container">
                                                            <div class="custom-spinner"></div>
                                                          </div>
                                                        }

                                                        @if (!isSubmitting && form.invalid && form.touched) {
                                                          <div class="error-message">
                                                            Please fill in all required fields.
                                                          </div>
                                                        }

                                                        @if (warningMessage) {
                                                          <div class="error-message">{{ warningMessage }}</div>
                                                        }

                                                      </form>
                                                    </mat-card-content>
                                                  </mat-card>
                                                  <br><br>

                                                  <div class="page-title">
                                                    <p class="form-desc-two">If form does not submit, ensure all required fields are answered. Additionally, depending on the network, the form submission may take a minute. If it still does not submit, reach out directly to <i class="contact">(pturner&#64;landpoint.net)</i> to get it handled. </p>
                                                  </div>
